// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"08ef42f3","796":"dcd92dd1"}[chunkId] + ".chunk.js";
};